export default "__VITE_ASSET__G92bh0kd__"